import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function LandingFooter() {
  return (
    <footer className="border-t border-border bg-card/30 py-12 px-6">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <AppLogo size={30} />
              <span className="font-bold text-sm text-foreground">FanFinite</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
              The competitive fan gaming platform. Prove your fandom knowledge, earn badges, and climb the ranks.
              Fan-made. Fan-powered.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3">Platform</p>
            <ul className="space-y-2">
              {['Features', 'Psych World', 'XP System', 'ID Card', 'Leaderboard']?.map((item) => (
                <li key={`footer-${item}`}>
                  <a href={`#${item?.toLowerCase()?.replace(' ', '-')}`} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">{item}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3">Account</p>
            <ul className="space-y-2">
              {[
                { label: 'Sign In', href: '/sign-up-login-screen' },
                { label: 'Create Account', href: '/sign-up-login-screen' },
                { label: 'Dashboard', href: '/user-dashboard' },
                { label: 'Admin Panel', href: '/admin-dashboard' },
              ]?.map((item) => (
                <li key={`footer-acc-${item?.label}`}>
                  <Link href={item?.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">{item?.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="section-divider pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © 2026 FanFinite. Fan-made platform. Not affiliated with any official IP holders.
          </p>
          <p className="text-xs text-muted-foreground">
            All game content is fan-created and unofficial.
          </p>
        </div>
      </div>
    </footer>
  );
}